import React, { lazy , Suspense } from 'react';
import {BrowserRouter,Route,Routes} from 'react-router-dom';


import './App.css';

import ToneLoader from './Components/commonComponents/Loaders/ToneLoader/index.js'












// <<<<<<!----------TELUGU ONE HOME PAGE ROUTES------------!>>>>>>>>>>>
const ToneHome = lazy(() => import('./Components/ToneHome/index.js') )
// <<<<<<!--------------------------------------!>>>>>>>>>>>>>>>>>>>>>>



//<<<<<<<!----------NEWS PAGE ROUTES------------!>>>>>>>>>>>
const News =lazy(() => import('./Components/News/index'))
const NewsMain = lazy(() => import('./Components/News/newsMain/index.js'))
const CategoryNews  = lazy(() => import('./Components/News/categoryNewsPage/index.js'))
const NewsContent = lazy(() => import('./Components/News/newsContent/index.js'))
const RssFeedsMain = lazy(() => import('./Components/News/rssFeeds/index.js'))
// <<<<<<!--------------------------------------!>>>>>>>>>>>


 
// <<<<<<!----------TMDB PAGE ROUTES------------!>>>>>>>>>>>
const Tmdb  = lazy(() => import('./Components/Tmdb/index.js'))
const TmdbPages  = lazy(() => import('./Components/TmdbPages/index'))
const TmdbMovieNews = lazy(() => import('./Components/TmdbPages/tmdbMovieNews/index'))
const  TmdbMovieReviews = lazy(() => import('./Components/TmdbPages/tmdbMovieReviews/index.js'))
const TmdbMovieReviewsMain  = lazy(() => import('./Components/TmdbPages/tmdbMovieReviews/tmdbReviewsMain.js'))
const TmdbMovieReviewsDetails = lazy(() => import('./Components/TmdbPages/tmdbMovieReviews/tmdbReviewDetails.js'))
const TmdbMovieCelebrities = lazy(() => import('./Components/TmdbPages/tmdbMovieCelebrities/index.js'))
const  TmdbVideoGossips = lazy(() => import('./Components/TmdbPages/tmdbVideoGossips/index.js'))
const  TmdbVideoGossipsMain = lazy(() => import('./Components/TmdbPages/tmdbVideoGossips/tmdbVideoGossipsMain.js'))
const TmdbVideoGossipDetails = lazy(() => import('./Components/TmdbPages/tmdbVideoGossips/tmdbVideoGossipDetails.js'))
const  TmdbMovieNewsContent = lazy(() =>import('./Components/TmdbPages/tmdbMovieNewsContent/index.js'))
// <<<<<<!--------------------------------------!>>>>>>>>>>>



// <<<<<!----------MOVIES ROUTES------------!>>>>>>>>>>>
const Movies  = lazy(() => import('./Components/Movies/index.js'))
const  MoviesHome = lazy(() => import('./Components/Movies/moviesHome/index.js'))
const MoviesCategory = lazy(() => import('./Components/Movies/moviesCategory/index.js'))
const MovieDetails  = lazy(() => import('./Components/Movies/movieDetails/index.js'))
// <<<<<<!--------------------------------------!>>>>>>>>>>>




// <<<<<!----------PHOTOS ROUTES------------!>>>>>>>>>>>
const Photos =lazy(() =>   import('./Components/Photos/index.js'))
const PhotosHome =lazy(() =>   import('./Components/Photos/PhotosHome/index.js'))
const PhotosCategory =lazy(() => import('./Components/Photos/PhotosCategory/index.js'))
const PhotosCategoryPrimary=lazy(() => import('./Components/Photos/PhotosCategoryPrimary/index.js'))
const PhotosCategoryIndividual=lazy(() => import('./Components/Photos/PhotosCategoryIndividual/index.js'))
const PhotosCategoryShowCase=lazy(() => import('./Components/Photos/PhotosCategoryShowCase/index.js'))
// <<<<<<!--------------------------------------!>>>>>>>>>>>


// <<<<<!----------DEVOTIONAL ROUTES------------!>>>>>>>>>>>

const Devotional=lazy(()=> import('./Components/Devotional/index.js'))
const DevotionalHome=lazy(() => import('./Components/Devotional/DevotionalHome/index.js'))
const DevotionalContentsPage=lazy(() =>import('./Components/Devotional/devotionalContentsPage.js'))
const DevotionalSubPages=lazy(() =>import('./Components/Devotional/devotionalSubPages.js'))
const DevotionalVideoList=lazy(() => import('./Components/Devotional/DevotionalVideoList/index.js'))
const DevotionalVideos=lazy(() => import('./Components/Devotional/DevotionalVideos/index.js'))
const DevotionalVideo=lazy(() => import('./Components/Devotional/DevotionalVideo/index.js'))
const DevotionalContent=lazy(() => import('./Components/Devotional/DevotionalContent/index.js'))
const DevotionalWeekly=lazy(() => import('./Components/Devotional/DevotionalWeekly/index.js'))
const DevotionalTithi=lazy(() => import('./Components/Devotional/DevotionalTithi/index.js'))
// <<<<<<!--------------------------------------!>>>>>>>>>>>



// <<<<<!----------GRANDALAYAM ROUTES------------!>>>>>>>>>>>
 const Grandalayam =lazy(() => import('./Components/Grandalayam/index.js'))
 const GrandalayamHome =lazy(() => import('./Components/Grandalayam/GrandalayamHome/index.js'))
 const GrandalayamCategory=lazy(() => import('./Components/Grandalayam/GrandalayamCategory/index.js'))
 const GrandalayamNovels=lazy(() => import('./Components/Grandalayam/GrandalayamCategory/GrandalayamNovels/index.js'))
 const GrandalyamNovelDetails=lazy(() =>import('./Components/Grandalayam/GrandalayamNovelDetails/index.js'))
 const GrandalayamWriters=lazy(() => import('./Components/Grandalayam/GrandalayamWriters/index.js'))
 // <<<<<<!--------------------------------------!>>>>>>>>>>>


// <<<<<!---------- VANITHA ROUTES------------!>>>>>>>>>>>
const Vanitha=lazy(() =>import('./Components/Vanitha/index.js'))
const VanithaHome=lazy(() => import('./Components/Vanitha/VanithaHome/index.js'))
const VanithaCategory=lazy(() => import('./Components/Vanitha/VanithaCategoryPage/index.js'))
const VanithaContent=lazy(() => import('./Components/Vanitha/VanithaContent/index.js'))
const VanithaRssFeeds =lazy(() => import('./Components/Vanitha/VanithaRssFeeds/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>


// <<<<<!---------- VIDEOS ROUTES------------!>>>>>>>>>>>
const Videos=lazy(() => import('./Components/Videos/index.js'))
const VideosHome=lazy(() => import('./Components/Videos/videosHome/index.js'))
const VideosCategoryPage=lazy(() => import('./Components/Videos/videosCategoryPage.js'))
const VideosContent= lazy(() => import('./Components/Videos/videosContent/index.js')) 
//<<<<<<!------------------------------------------!>>>>>>>>>>>

// <<<<<!---------- RECIPES ROUTES------------!>>>>>>>>>>>
const Recipes=lazy(() => import('./Components/Recipes/index.js'))
const RecipesHome=lazy(() => import('./Components/Recipes/recipesHome/index.js'))
const RecipesCategoryPage=lazy(() => import('./Components/Recipes/recipesCategoryPage/index.js'))
const RecipesContent=lazy(() =>  import('./Components/Recipes/recipesContent/index.js'))
const SearchedRecipesPage=lazy(() => import('./Components/Recipes/recipesSearchResultsPage/index.js'))
const RecipeVideosPage=lazy(() => import('./Components/Recipes/recipeVideos/recipeVideosPage.js'))
const VideosList=lazy(() => import('./Components/Recipes/recipeVideos/videosList.js'))

const RecipeVideoContent = lazy(() => import('./Components/Recipes/recipeVideos/recipeVideoContent.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>

// <<<<<!---------- HEALTH ROUTES------------!>>>>>>>>>>>
const Health=lazy(() => import('./Components/Health/index.js'))
const HealthHome=lazy(() => import('./Components/Health/HealthHome/index.js'))
const HealthCategory=lazy(() => import('./Components/Health/HealthCategory/index.js'))
const VideoCentreCategorySection=lazy(() => import('./Components/Health/HealthCategory/videoCentreCategorySection.js'))
const DoctorsCategorySection=lazy(() => import('./Components/Health/HealthCategory/doctorCategorySection.js'))
const HealthContent =lazy(() => import('./Components/Health/HealthContent/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>

// <<<<<!---------- SHORT FILMS ROUTES------------!>>>>>>>>>>>

const ShortFilms=lazy(() => import('./Components/ShortFilms/index.js'))
const ShortFilmsHome=lazy(() => import('./Components/ShortFilms/ShortFilmsHome/index.js'))
const ShortFilmsDetailsPage=lazy(() => import('./Components/ShortFilms/ShortFilmsCategory/shortFilmsDetailsPage.js'))
const ShortFilmsEachCategory=lazy(() => import('./Components/ShortFilms/ShortFilmsCategory/index.js'))
const ShortFilmsContent=lazy(() => import('./Components/ShortFilms/ShortFilmsContent/index.js'))
const ShortFilmsContributorsAllPage=lazy(() => import('./Components/ShortFilms/ShortFilmsContributorsAllPage/index.js'))
const ContributorsContent=lazy(() => import('./Components/ShortFilms/ShortFilmsContributorsContent/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>

// <<<<<!---------- COMEDY ROUTES------------!>>>>>>>>>>>
const Comedy=lazy(() => import('./Components/Comedy/index.js'));
const ComedyHome=lazy(() => import('./Components/Comedy/comedyHome/index.js'))
const ComedyContentsPage=lazy(() => import('./Components/Comedy/comedyContentsPage/index.js'))
const ComedyGalleriesPage=lazy(() => import('./Components/Comedy/comedyGalleriesPage/index.js'))
const ComedyVideosPage=lazy(() => import('./Components/Comedy/comedyVideosPage/index.js'))
const ComedyStoriesSerials=lazy(() => import('./Components/Comedy/comedyStoriesSerialsPage/index.js'))
const ComedyContent =lazy(() => import('./Components/Comedy/comedyContent/index.js'))
const ComedyVideoDetails= lazy(() => import('./Components/Comedy/comedyVideoDetails/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>



// <<<<<!---------- ASTROLOGY ROUTES------------!>>>>>>>>>>>

const Astrology=lazy(() => import('./Components/Astrology/index.js'))
const AstrologyHome=lazy(() => import('./Components/Astrology/AstrologyHome/index.js'))
const AstrologySubCategoryPage=lazy(() => import('./Components/Astrology/AstrologySubCategoryPage/index.js'))
const AstrologySubCategoryContent=lazy(() => import('./Components/Astrology/AstrologySubCategoryPage/astrologySubCategoryContent.js'))
const AstrologyPanchangam=lazy(() => import('./Components/Astrology/AstrologyPanchangam/index.js'))

//<<<<<<!------------------------------------------!>>>>>>>>>>>


// <<<<<!---------- SAHITYAM ROUTES------------!>>>>>>>>>>>
const Sahityam=lazy(() => import('./Components/Sahityam/index.js'))
const SahityamHome=lazy(() => import('./Components/Sahityam/SahityamHome/index.js'));
const SahityamCategory=lazy(() => import('./Components/Sahityam/SahityamCategory/index.js'))
const SahityamContent=lazy(() => import('./Components/Sahityam/SahityamContent/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>

// <<<<<!----------  GREETINGS  ROUTES------------!>>>>>>>>>>>

const ToneGreetings =lazy(() => import('./Components/Greetings/index.js'))
const GreetingsHome =lazy(() => import('./Components/Greetings/GreetingsHome/index.js'))
const GreetingsDisplayPage =lazy(() => import('./Components/Greetings/GreetingsDisplayPage/index.js'))
const GreetingsSendingCardPage = lazy(() => import('./Components/Greetings/GreetingsSendingCardPage/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>


const Splevents =lazy(() => import('./Components/Splevents/index.js'))
const SpleventsHome = lazy(() => import('./Components/Splevents/SpleventsHome/index.js'))
const SpleventsPage=  lazy(() => import('./Components/Splevents/SpleventsPage/index.js'))
const SpleventPageCategories = lazy(() => import('./Components/Splevents/SpleventsPage/spleventsPageCategories.js'))
const SpleventContent = lazy(() => import('./Components/Splevents/SpleventContent/index.js'))



// <<<<<<!----------PAGE NOT FOUND ROUTES------------!>>>>>>>>>>>>>
const PageNotFound=lazy(() => import ('./Components/NotFound/index.js'))
//<<<<<<!------------------------------------------!>>>>>>>>>>>>>>





  




function App() { 
  
  return (
    <div className="App d-flex flex-column align-items-center">
        <BrowserRouter>
        <Suspense fallback={<ToneLoader />}>  
        <Routes>

                  {/*********************************** ToneHome *************************************/}
                    <Route exact  path="/" element={<ToneHome />} />


                  {/*********************************** NEWS *************************************/}
                    <Route path="/news" element={<News />}>
                                    <Route index  element={<NewsMain />} />
                                 
                                    <Route path="/news/:type" element={<CategoryNews catId={45} cat={"analyticsnews"} />} />
                                    <Route path="/news/content/:contentText"   element={<NewsContent />} />
                                    <Route path="/news/rssdetails"  element={<RssFeedsMain  />} />
                    </Route>



                  {/*********************************** TMDB *************************************/}
                      <Route path="/tmdb" element={<Tmdb />}  />                           
                     <Route path="/tmdb/pages" element={<TmdbPages />}>
                  
                                    <Route path=":category" element={<TmdbMovieNews />} />
                                    <Route path="reviews" element={<TmdbMovieReviews />} >
                                          <Route index element={<TmdbMovieReviewsMain />} />
                                    </Route>

                                    <Route path="celebrities" element={<TmdbMovieCelebrities />} />
                                    <Route path="videogossips" element={<TmdbVideoGossips  />} >
                                    <Route index element={<TmdbVideoGossipsMain />} />
                                    <Route path="details/:content" element={<TmdbVideoGossipDetails />} />
                                    </Route>
                   </Route>
                    <Route path="/tmdb/:category/:content" element={<TmdbPages />}>
                              <Route index element={<TmdbMovieNewsContent />} />
                    </Route>

                    <Route path="/tmdb/moviereview/:content" element={<TmdbPages />}>
                              <Route index element={<TmdbMovieReviewsDetails />} />
                    </Route>


                    

                  {/*********************************** MOVIES *************************************/}
                    <Route path="/movies" element={<Movies />}>
                        <Route index element={<MoviesHome  homeActivedwnldLink={"Home"} />} />
                        <Route path="category/:cat" element={<MoviesCategory  />}  />   
                        <Route path="details/:id" element={<MovieDetails />}  />   
                    </Route>

                  {/*********************************** PHOTOS *************************************/}
                    <Route path="/photos" element={<Photos />}>

                        <Route index element={<PhotosHome />} />
                        <Route  path='/photos/actress' element={<PhotosCategory  />} >
                              <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/actress/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/actress/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                        <Route  path='/photos/actors' element={<PhotosCategory  />} >
                              <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/actors/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/actors/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                        <Route  path='/photos/events' element={<PhotosCategory   />} >
                                    <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/events/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/events/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                        <Route  path='/photos/wallpapers' element={<PhotosCategory  />} >
                                    <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/wallpapers/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/wallpapers/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                        <Route  path='/photos/kingsize' element={<PhotosCategory  />} >
                              <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/kingsize/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/kingsize/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                        <Route  path='/photos/others' element={<PhotosCategory  />} >
                                    <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/others/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/others/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                        <Route  path='/photos/movies' element={<PhotosCategory  />} >
                              <Route index  element={<PhotosCategoryPrimary />} />
                              <Route path="/photos/movies/individual"  element={<PhotosCategoryIndividual />} />
                              <Route path="/photos/movies/individualShowCase" element={<PhotosCategoryShowCase />} />
                        </Route>
                    </Route>

                  {/*********************************** DEVOTIONAL *************************************/}
                   
                    <Route path="/devotional" element={<Devotional />}>

                        <Route index element={<DevotionalHome />} />
                        
                        <Route path="contents/:category" element={<DevotionalContentsPage />} />
                              
                        <Route path="subpages/:category" element={<DevotionalSubPages />} />

                        <Route path="videolist/:video" element={<DevotionalVideoList />} />

                        <Route path="videos" element={<DevotionalVideos />} />

                        <Route path="video/:content" element={<DevotionalVideo />} />

                        <Route path="content/:content" element={<DevotionalContent />} />
                        
                        <Route path="weekly/:charecter" element={<DevotionalWeekly />} />

                        <Route path="tithi" element={<DevotionalTithi />} />
                        

                    </Route> 

                  {/*********************************** GRANDALAYAM *************************************/}
                    <Route path="/grandalayam" element={<Grandalayam />}>
                        <Route index element={<GrandalayamHome />} />
                        <Route path='novels'  element={<GrandalayamCategory />} >
                              <Route index element={<GrandalayamNovels />} />
                              <Route path='details/:novel' element={<GrandalyamNovelDetails />} />
                        </Route>
            
                        <Route path='writers/publications' element={<GrandalayamWriters />} />
                        <Route path='writers/history' element={<GrandalayamWriters />} />
                        <Route path='writers/individual' element={<GrandalayamWriters />} />
                        

                    </Route>

                  {/*********************************** VANITHA *************************************/}
                    <Route path="/vanitha" element={<Vanitha />}>
                        <Route index element={<VanithaHome />}   />
                         <Route path='contents/:category' element={<VanithaCategory />} />
                         <Route path="content/:content" element={<VanithaContent />} />
                         <Route path="rssdetails" element={<VanithaRssFeeds />} />
                    </Route>

                  {/*********************************** VIDEOS *************************************/}
                  <Route path="/videos" element={<Videos />} >
                         <Route index element={<VideosHome/>}   />
                         <Route path="page/:category" element={<VideosCategoryPage />} >
                             
                         </Route>
                         {/* <Route path="webseries" element={<VideosIndividualCategory />} />
                         <Route path="comedy/funbucket" element={<VideosIndividualCategory />} />
                         <Route path="sub/mehndi" element={<VideosIndividualCategory />} /> */}
                         <Route path="single/:category/:content" element={<VideosContent />} />
                  </Route>

                  {/*********************************** RECIPES *************************************/}
                   <Route path="/recipes" element={<Recipes />} >
                         <Route index element={<RecipesHome/>}   />
                         <Route path="contents/:type" element={<RecipesCategoryPage />} />
                         <Route path='content/:contentname' element={<RecipesContent />} />
                         <Route path='contents/searched/:inputTxt' element={<SearchedRecipesPage />} />
                         <Route path='recipeVideos' element={<RecipeVideosPage />} >
                                 <Route index element={<VideosList />} />
                         </Route>
                         <Route path="showvideo/:content" element={<RecipeVideoContent />} />
                   </Route>

                  {/*********************************** RECIPES *************************************/}
                   <Route path='/health' element={<Health />} >
                         <Route index element={<HealthHome />} />
                         <Route path="contents/everyday-health" element={<HealthCategory />} />
                         <Route path="contents/staying-healthy" element={<HealthCategory />} />
                         <Route path="contents/diet-and-fitness" element={<HealthCategory />} />
                         <Route path="contents/yoga" element={<HealthCategory />} />
                         <Route path="contents/video-centre" element={<VideoCentreCategorySection />} />
                         <Route path="contents/news-and-experts" element={<DoctorsCategorySection />} />

                         <Route path="content/:id" element={<HealthContent />} />
                   </Route> 


                  {/*********************************** RECIPES *************************************/}
                   <Route path="/shortfilms" element={<ShortFilms />}>
                          <Route index  element={<ShortFilmsHome />}  />
                          <Route path='details' element={<ShortFilmsDetailsPage />} />
                          <Route path='categories/:category' element={<ShortFilmsEachCategory />} />
                          <Route path="films/:filmname" element={<ShortFilmsContent />} />
                          <Route path='profesionals/details' element={<ShortFilmsContributorsAllPage />} />
                          <Route path='profesionals/:profesional' element={<ContributorsContent />} />
                   </Route>

                  {/*********************************** COMEDY *************************************/}
                   <Route path="/comedy" element={<Comedy />}>
                       <Route  index element={<ComedyHome />}></Route>
                       <Route path="mallik" element={<ComedyContentsPage  breadCrumb={"Mallik"} />} />
                       <Route path="contents/audiojokes" element={<ComedyContentsPage  breadCrumb={"Audio Jokes"} />} />
                       <Route path="contents/audiocartoons" element={<ComedyContentsPage breadCrumb={"Audio Cartoons"} />} />
                       <Route path="contents/mallikcrazy" element={<ComedyContentsPage breadCrumb={"Mallik Crazy"} />} />
                       <Route path="contents/hotshot" element={<ComedyContentsPage breadCrumb={"Hot Shot"} />}  />
                       <Route path="contents/siggusiggu" element={<ComedyContentsPage breadCrumb={"Siggu Siggu"} />} />
                       <Route path="contents/facebook-fun" element={<ComedyContentsPage breadCrumb={"Facebook Fun"} />} />
                       <Route path="contents/jokes" element={<ComedyContentsPage breadCrumb={"Jokes"} />} />
                       <Route path="galleries/chittiArchive" element={<ComedyGalleriesPage breadCrumb={"Chitti Archive"} />} />
                       <Route path="videos" element={<ComedyVideosPage breadCrumb={"Video Galleries"} />} />
                       <Route path="videoslists/erridippa" element={<ComedyContentsPage breadCrumb={"Erri Dippa"} video={true} /> } />
                       <Route path="videoslists/spoofs" element={<ComedyContentsPage breadCrumb={"Spoofs"} video={true} /> }  />
                       <Route path="videoslists/mallikcomedy" element={<ComedyContentsPage breadCrumb={"Mallik Comedy"} video={true} /> }  />
                       <Route path="videoslists/shhgupchip" element={<ComedyContentsPage breadCrumb={"Shh Gup Chip"}  video={true} /> }  />
                       <Route path="videoslists/happyhappyga" element={<ComedyContentsPage breadCrumb={"Happy Happy ga"} video={true} /> } />
                       <Route path="videoslists/telugucomedyvideos" element={<ComedyContentsPage breadCrumb={"Telugu Comedy Videos"} video={true} /> } />
                       <Route path="videoslists/archives" element={<ComedyContentsPage breadCrumb={"Archives"} video={true}  /> } />

                        <Route path="storiesserials" element={<ComedyStoriesSerials />} />

                        <Route path="content/:name" element={<ComedyContent />} />
                         <Route path="pictures/:name" element={<ComedyContent />} />
                        <Route path="serials/:name" element={<ComedyContent />} />
                       
                       <Route path="videodetails/:name" element={<ComedyVideoDetails />} />
                       
                   </Route>

                  {/***********************************ASTROLOGY *************************************/}
  
                  <Route path="/toneastrology" element={<Astrology />}>
                        <Route  index element={<AstrologyHome />} />
                        <Route path="/toneastrology/subcategory/:category" element={<AstrologySubCategoryPage />} />
                        <Route path="/toneastrology/subcategory/content/:content" element={<AstrologySubCategoryContent  />} />
                        <Route path="/toneastrology/panchangam/videos/:video" element={<AstrologyPanchangam  />} /> 
                        <Route path="/toneastrology/panchangam/downloads/:zip" element={<AstrologyPanchangam  />} />
                        <Route path="/toneastrology/calendars/:calendar" element={<AstrologyPanchangam  />} />
                
                  </Route>
                  
                  {/*********************************** SAHITYAM *************************************/}
                  <Route path="/sahityam" element={<Sahityam />}>
                       <Route index element={<SahityamHome />} />
                       <Route path="category/:category" element={<SahityamCategory />} />
                       <Route path='content/:contentName' element={<SahityamContent />} />  
                  </Route>

                  {/*********************************** TONE GREETINGS *************************************/}
                  <Route path="tonegreetings" element={<ToneGreetings />}>
                            <Route index element={<GreetingsHome />} />
                            <Route path='categorywise/:category' element={<GreetingsDisplayPage />} />
                            <Route path="sendingdetails/:sending" element={<GreetingsSendingCardPage />} />
                  </Route>

                  {/*********************************** SPL EVENTS *************************************/}
                  <Route path="splevents" element={<Splevents />} >
                            <Route index element={<SpleventsHome />} />
                            <Route path=":event" element={<SpleventsPage />} >
                                   <Route index element={<SpleventPageCategories />} />
                                   <Route path=':contentcat' element={<SpleventContent />} />
                            </Route>
                            
                  </Route>
          

             { /*

              <Route path="/charity" element={<Charity />}></Route>
              <Route path="/nri" element={<Nri />}></Route>
              <Route path="/help" element={<Help />}></Route>
              <Route path="/siteMap" element={<SiteMap />}></Route>
              <Route path="/siteTour" element={<SiteTour />}></Route>
              <Route path="/recommend" element={<Recommend />}></Route>
              <Route path="/faq" element={<Faq />}></Route>
              <Route path="/contactInfo" element={<ContactInfo />}></Route>
              <Route path="/feedback" element={<FeedBack/>}></Route>
               */}

              <Route path="*" Component={PageNotFound} /> 
    
          </Routes>
        
          </Suspense>
       </BrowserRouter>
     
    </div>
  );
}



export default App;














